import React from 'react'
import { TextField, InputAdornment, IconButton } from "@mui/material";
import UseAnimations from "react-useanimations";
import visibility from 'react-useanimations/lib/visibility';
import "./TextFieldComponent.css";
import moment from 'moment';

function TextFieldComponent(props) {

    const id = props.id;
    const input = props.handler.form[id];
    const label = input.label;
    const type = input.type;
    const [error, setError] = React.useState(input.error);
    const [isFocus, setFocus] = React.useState(false);
    const [showPassword, setShowPassword] = React.useState(type === 'password');
    const isVisibility = type === 'password';

    const [value, setValue] = React.useState('');
    React.useEffect(() => {
        if (input.value !== undefined) {
            let nextValue;
            if (type === "time" && props.selectedDate && moment(input.value, "YYYY-MM-DD HH:mm:ss", true).isValid()) {
                nextValue = moment(input.value, "YYYY-MM-DD HH:mm:ss").format("HH:mm");
            } else {
                nextValue = input.value.toString();
            }

            setValue((previous) => (previous !== nextValue ? nextValue : previous));
        }
    }, [input.value, props.selectedDate, type]);

    React.useEffect(() => {
        setError((previous) => (previous !== input.error ? input.error : previous));
    }, [input.error]);

    const onChange = (event) => {
        let newValue = event.target.value ?? '';

        if (newValue) {
            if (type === 'integer') {
                if ((newValue.toString().match(/^-?\d*$/i) === null)) {
                    newValue = value;
                }
            }
            else if (type === 'float') {
                if ((newValue.toString().match(/^-?[0-9]*\.?[0-9]*$/i) === null)) {
                    newValue = value;
                }
            }

            if (type === "time" && props.selectedDate) {
                const datePart = moment(props.selectedDate).format("YYYY-MM-DD");
                let timePart = newValue;
                if (timePart.length === 5) {
                    timePart = timePart + ":00";
                }
                const fullDatetime = moment(`${datePart} ${timePart}`, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss");
                props.handler.setValue(id, fullDatetime);
                newValue = moment(fullDatetime, "YYYY-MM-DD HH:mm:ss").format("HH:mm");
            }

            if (input.options.max) {
                let length = (type === 'text' || type === 'password') ? newValue.toString().length : newValue;
                if (!(input.options.max && length <= input.options.max)) {
                    newValue = value;
                }
            }

            if (input.options.inf) {
                let length = (type === 'text' || type === 'password') ? newValue.toString().length : newValue;
                if (!(input.options.inf && length < input.options.inf)) {
                    newValue = value;
                }
            }

            if (input.options.equal) {
                let length = (type === 'text' || type === 'password') ? newValue.toString().length : newValue;
                if (!(input.options.equal && length <= input.options.equal)) {
                    newValue = value;
                }
            }
        }
        setValue(newValue);
        if (props.onChange) props.onChange(newValue);

        if (!isFocus) {
            setFocus(false);
            if (type !== "time") {
                props.handler.setValue(id, newValue);
            }
            let err = props.handler.getErrorByField(input);
            setError(err);
            props.handler.setError(id, err);
        }
    };

    const onBlur = () => {
        setFocus(false);
        if (type !== "time") {
            props.handler.setValue(id, value);
        }
        let err = props.handler.getErrorByField(input);
        setError(err);
        props.handler.setError(id, err);
        if (props.onBlur) setTimeout(props.onBlur, 250);
    };

    const onFocus = () => {
        setFocus(true);
        if (props.onFocus) setTimeout(props.onFocus, 250);
    };

    return (
        <div className={'content-textfield'}>
            <TextField
                style={props.style ? props.style : {}}
                inputRef={props.inputRef ?? null}
                autoComplete={props.autoComplete === false ? 'off' : 'on'}
                onKeyDown={(e) => {
                    if (props.onScan && e.key === 'Enter') {
                        props.onScan(value);
                        setTimeout(() => {
                            props.handler.setValue(id, '');
                            setValue('');
                        }, 100);
                    }
                    if (props.onSubmit && e.key === "Enter") {
                        onBlur();
                        props.onSubmit();
                    }
                }}
                multiline={props.multiline}
                rows={3}
                slotProps={{
                    inputLabel: { shrink: true },
                    input: {
                        autoFocus: props.autoFocus,
                        ...(props.adornmentOrientation && props.adornmentOrientation === 'left'
                            ? {
                                  startAdornment: type === 'password' ? (
                                      <InputAdornment position="end" disabled={input.disabled || props.disabled}>
                                          <IconButton
                                              onClick={() => setShowPassword(!showPassword)}
                                              edge="end"
                                              disabled={input.disabled || props.disabled}
                                          >
                                              {isVisibility && <UseAnimations animation={visibility} reverse={showPassword} />}
                                          </IconButton>
                                      </InputAdornment>
                                  ) : props.adornment ? props.adornment : <></>,
                              }
                            : {
                                  endAdornment: type === 'password' ? (
                                      <InputAdornment position="end" disabled={input.disabled || props.disabled}>
                                          <IconButton
                                              onClick={() => setShowPassword(!showPassword)}
                                              edge="end"
                                              disabled={input.disabled || props.disabled}
                                          >
                                              {isVisibility && <UseAnimations animation={visibility} reverse={showPassword} />}
                                          </IconButton>
                                      </InputAdornment>
                                  ) : props.adornment ? props.adornment : <></>,
                              }),
                    },
                }}
                id={id}
                label={
                    label +
                    ((input.options && input.options.validation && input.options.validation.indexOf('required') > -1)
                        ? ' *'
                        : '')
                }
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                onFocus={onFocus}
                variant="outlined"
                type={type === 'time' ? 'time' : (showPassword ? 'password' : 'text')}
                disabled={input.disabled || props.disabled}
                className={`textField ${
                    isFocus
                        ? 'textFieldFocus'
                        : error
                        ? 'textFieldError'
                        : value && (!input.disabled && !props.disabled)
                        ? 'textFieldValid'
                        : ''
                }`}
                helperText={error && !isFocus ? error : input.textHelper}
            />
        </div>
    );
}

export default TextFieldComponent;
